import { CvSectionConfigClass, CvSectionConfigDTO } from './cv-section-config-dto';
import { DateRangeDTO } from '../core/date/date-range-dto';

export interface CvEntitySectionDTO extends CvSectionConfigDTO {
    type: 'entity';
    sortBy: string;
    dateRange: DateRangeDTO<string>;
    groupBySecondaryFilter: boolean;
}

export class CvEntitySectionClass extends CvSectionConfigClass implements CvEntitySectionDTO {
    type: 'entity';
    sortBy: string = null;
    dateRange: DateRangeDTO<string> = { start: null, end: null };
    groupBySecondaryFilter: boolean;

    constructor(section: CvEntitySectionClass) {
        super(section);
        Object.assign(this, section);
    }
    
}